const COMPANY_ACCESS_PATH_REGEX = /^\/(?:empresa|empresas|company|companies|c)\/([^/?#]+)\/?$/i;

const stripAccents = (value = '') => {
  return String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
};

export const sanitizeCompanyAccessSlug = (value = '', fallback = '') => {
  const source = String(value || fallback || '').trim();

  const normalized = stripAccents(source)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .replace(/-{2,}/g, '-');

  if (normalized) return normalized;

  const fallbackNormalized = stripAccents(String(fallback || 'empresa').trim())
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .replace(/-{2,}/g, '-');

  return fallbackNormalized || 'empresa';
};

export const buildCompanyAccessPath = (companyKey = '') => {
  const normalized = String(companyKey || '').trim();
  if (!normalized) return '/empresa';
  return `/empresa/${encodeURIComponent(normalized)}`;
};

export const buildCompanyAccessUrl = (companyKey = '', origin = '') => {
  const path = buildCompanyAccessPath(companyKey);
  const safeOrigin = String(origin || (typeof window !== 'undefined' ? window.location.origin : '')).trim();
  return safeOrigin ? `${safeOrigin}${path}` : path;
};

export const getCompanyAccessKeyFromPath = (pathname = '') => {
  const path = String(pathname || '').trim();
  const match = path.match(COMPANY_ACCESS_PATH_REGEX);

  if (!match?.[1]) return null;

  try {
    return decodeURIComponent(match[1]);
  } catch (error) {
    return match[1];
  }
};